import type {
  LoaderConfig,
  MediaConfig,
  NpawAnalyticsPluginConfig,
  NPAWMediaPluginConfig,
} from "@foundation-player/loader";
import { Media } from "./media_player.types";
import { Plugin } from "./media_plugin.js";

/**
 * For further information on the Npaw plugin, please also refer
 * to the corresponding API documentation in the Foundation Player documentation:
 *
 * @see https://docs.player.foundation/v1/integration/available-plugins/#npaw-analytics
 * @see https://docs.player.foundation/v1/api/types/interfaces/npawmediapluginconfig/
 */
export class PluginNpaw extends Plugin {
  public constructor(media: Media) {
    super(media);
  }

  public isEnabled(): boolean {
    return true;
  }

  public addFoundationLoaderConfig(): LoaderConfig["pluginConfigs"] {
    const npawAnalyticsPluginConfig: NpawAnalyticsPluginConfig = {
      userType: this.media.userPlus ? "paid" : "free",
    };
    return {
      "foundation.plugin.npawAnalytics": npawAnalyticsPluginConfig,
    };
  }

  public addFoundationMediaConfig(): Partial<MediaConfig> {
    console.log("NPAW Media Plugin Config", this.media);
    const npawMediaPluginConfig: NPAWMediaPluginConfig = {
      channelName: this.media.scope,
      title: this.media.tracking?.staticTitle,
      id: this.media.id,
    };
    return {
      plugins: {
        "foundation.plugin.npawAnalytics": npawMediaPluginConfig,
      },
    };
  }
}
